var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment-method-chart",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _c("HalfPieChart", {
        attrs: {
          series: _vm.getSeries(),
          colors: ["#cb5d0f", "#4213ce", "#c9d906"],
        },
      }),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.total"),
              value: _vm.stats.TotalSiteCount,
              unit: "site",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.stats.paymentMethods, function (paymentMethod, index) {
            return _c("StatCard", {
              key: index,
              attrs: {
                title: paymentMethod.name,
                value: paymentMethod.value,
                unit: "adet",
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }